import React from "react"

import Expand from "@irati/ui/src/Expander"
import {Label2} from "@irati/ui/src/Labels"
import FormattedMessage from "@irati/utils/lang"
import {CheckoutRedemptionOrder} from "@irati/types"
import OrderWrapper from "./styled/OrderWrapper"
import OrderDetails from "./OrderDetails"

interface Props {
  order?: CheckoutRedemptionOrder
}

const SuccessOrderSummary: React.FC<Props> = (props) => {
  const {order} = props
  const totalValue = order?.totals?.total?.value || 0

  if (!order || totalValue === 0) {
    return null
  }

  return (
    <OrderWrapper>
      <Expand HeaderLabel={Label2} showText={<FormattedMessage id="perks.components.dealSuccessOrderSummary.orderSummary.expand" />}>
        <OrderDetails order={order} />
      </Expand>
    </OrderWrapper>
  )
}

export default SuccessOrderSummary
